

<script lang="ts">
import { createEventDispatcher } from "svelte";


import { SERVICE_URL } from "../evironment";
import { getAccessToken } from "../services/session";

export let contextId: string;
export let locked: boolean = false;

const dispacht = createEventDispatcher();
let input: HTMLInputElement;


async function onChange(){
    if (input.files.length === 0) {
        return
    }

    try {
        const file = input.files[0];
        input.value = '';

        let url = new URL('/api/files', SERVICE_URL);

        if (SERVICE_URL.includes('localhost') ) {
            url = new URL('/files', SERVICE_URL);
        }
        
        const formData = new FormData();
        formData.set('contextId', contextId);
        formData.set('locked', locked.toString());
        formData.set('file', file);

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Access-Token': getAccessToken()
            }
        })

        if (!response.ok) {
            throw new Error('Error al subir el fichero');
        }

        const content = await response.json();

        dispacht('upload', content);

    } catch (error) {
        console.log(error);
    }


}


</script>

<input type="file" class="d-none" bind:this={input} on:change={onChange}>

<button type="button" class="btn btn-primary" on:click={() => input.click()}>
    Subir
</button>